import Head from './../components/Head.vue';
import { getUrlParams } from '@/plugins/utils';
import Footer from '../components/Footer.vue';
export default {
  components: {
    Head,
    Footer
  },

  created() {
    this.course_outline_page();
  },

  mounted() {},

  data() {
    return {
      menuId: this.$utils.getUrlParams('menuId'),
      input4: '',
      title: '',
      courseList: [{
        name: '1-3海洋机器人',
        time: '2020-07-20'
      }, {
        name: '请确保已上传其他附件再删除本附件，如未上传其他附件则会导致学院被删除',
        time: '2020-07-20'
      }, {
        name: '1-3海洋机器人',
        time: '2020-07-20'
      }, {
        name: '请确保已上传其他附件再删除本附件，如未上传其他附件则会导致学院被删除',
        time: '2020-07-20'
      }, {
        name: '1-3海洋机器人',
        time: '2020-07-20'
      }, {
        name: '请确保已上传其他附件再删除本附件，如未上传其他附件则会导致学院被删除',
        time: '2020-07-20'
      }, {
        name: '1-3海洋机器人',
        time: '2020-07-20'
      }, {
        name: '请确保已上传其他附件再删除本附件，如未上传其他附件则会导致学院被删除',
        time: '2020-07-20'
      }]
    };
  },

  methods: {
    async course_outline_page() {
      let res = await this.$http.course_outline_page({
        keyword: this.input4,
        organ_id: this.$utils.getUrlParams('organId')
      });
      this.title = res && res.length > 0 ? res[0].organName : '';
      this.courseList = res && res.length > 0 ? res[0].outlines : [];
    },

    openFile(item) {
      window.open(`https://www.zhihuishu.com/columnsapp/student/previewPDF.html?url=${item.url}`);
    }

  }
};